import axios from "axios"
import { call, put, select } from "redux-saga/effects"
import { appActions } from "redux/app/slice/app"
import slice from "../slice/user"

const baseUrl = process.env.REACT_APP_API_MY_URL

export function* getHotelList() {
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(axios.get, `${baseUrl}/hotel/parent-mappings/`)
    if (data.success) {
      yield put(slice.actions.setHotelList(data?.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getHotelCategoryList(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(
      axios.get,
      `${baseUrl}/hotel/configurations/?hotel_id=${action.payload}`
    )
    if (data.success) {
      yield put(slice.actions.setHotelCategoryList(data?.data))
      yield put(slice.actions.setDynamicFieldsGroup(data?.data[0]?.dynamic_fields))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* createHotelCategory(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { hotelID } = yield select((store) => store?.hotel)
    const { payload, onClose } = action.payload
    const { data } = yield call(axios.post, `${baseUrl}/hotel/configurations/`, payload)
    if (data.success) {
      onClose()
      const { data: newData } = yield call(
        axios.get,
        `${baseUrl}/hotel/configurations/?hotel_id=${hotelID}`
      )
      if (newData.success) {
        yield put(slice.actions.setHotelCategoryList(newData?.data))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getHotelCategoryDetail(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(
      axios.get,
      `${baseUrl}/hotel/configurations/?config_id=${action.payload}`
    )
    if (data.success) {
      yield put(slice.actions.setHotelCategoryDetail(data?.data))
      yield put(slice.actions.setDynamicFieldsGroup(data?.data?.dynamic_fields))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* editHotelCategory(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { hotelID } = yield select((store) => store?.hotel)
    const { payload, id, onClose } = action.payload
    const { data } = yield call(axios.patch, `${baseUrl}/hotel/configurations/${id}/`, payload)
    if (data.success) {
      yield put(slice.actions.setHotelCategoryDetail(data?.data))
      onClose()
      const { data: newData } = yield call(
        axios.get,
        `${baseUrl}/hotel/configurations/?hotel_id=${hotelID}`
      )
      if (newData.success) {
        yield put(slice.actions.setHotelCategoryList(newData?.data))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* deleteHotelCategory(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { hotelID } = yield select((store) => store?.hotel)
    const { id, setSelectedCategoryId } = action.payload
    const { data } = yield call(axios.delete, `${baseUrl}/hotel/configurations/${id}/`)
    if (data.success) {
      const { data: newData } = yield call(
        axios.get,
        `${baseUrl}/hotel/configurations/?hotel_id=${hotelID}`
      )
      if (newData.success) {
        yield put(slice.actions.setHotelCategoryList(newData?.data))
        setSelectedCategoryId(newData?.data[0]?.id)
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getDynamicFields(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(
      axios.get,
      `${baseUrl}/hotel/configurations/?config_id=${action.payload}`
    )
    if (data.success) {
      yield put(slice.actions.setDynamicFieldsGroup(data?.data?.dynamic_fields))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* addDynamicFields(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { id, payload, onClose } = action.payload
    const { data } = yield call(axios.patch, `${baseUrl}/hotel/configurations/${id}/`, payload)
    if (data.success) {
      onClose()
      const { data: newData } = yield call(
        axios.get,
        `${baseUrl}/hotel/configurations/?config_id=${id}`
      )
      if (newData.success) {
        yield put(slice.actions.setHotelCategoryDetail(newData?.data))
        yield put(slice.actions.setDynamicFieldsGroup(newData?.data?.dynamic_fields))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getHotelSubCategory(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { id } = action.payload
    const { data } = yield call(axios.get, `${baseUrl}/hotel/subcategories/?hotel_config=${id}`)
    if (data.success) {
      yield put(slice.actions.setHotelSubCategoryList(data?.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* createHotelSubCategory(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { payload, onClose } = action.payload

    const { data } = yield call(axios.post, `${baseUrl}/hotel/subcategories/`, payload)
    if (data.success) {
      onClose()
      const { data: newData } = yield call(
        axios.get,
        `${baseUrl}/hotel/subcategories/?hotel_config=${payload.hotel_config}`
      )
      if (newData.success) {
        yield put(slice.actions.setHotelSubCategoryList(newData?.data))
      }
    } else {
      yield put(slice.actions.setHotelSubCategoryList([]))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getHotelNestedCategory(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { id } = action.payload
    const { data } = yield call(
      axios.get,
      `${baseUrl}/hotel/nested-subcategories/?subcategory_id=${id}`
    )
    if (data.success) {
      yield put(slice.actions.setHotelNestedCategoryList(data?.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* createHotelNestedCategory(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { payload, onClose } = action.payload
    const { data } = yield call(axios.post, `${baseUrl}/hotel/nested-subcategories/`, payload)
    if (data.success) {
      onClose()
      const { data: newData } = yield call(
        axios.get,
        `${baseUrl}/hotel/nested-subcategories/?subcategory_id=${payload.subcategory_id}`
      )
      if (newData.success) {
        yield put(slice.actions.setHotelNestedCategoryList(newData?.data))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getHotelNestedSubCategory(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { id } = action.payload
    const { data } = yield call(
      axios.get,
      `${baseUrl}/hotel/nested-nested-subcategories/?nested_subcategory_id=${id}`
    )
    if (data.success) {
      yield put(slice.actions.setHotelNestedSubCategoryList(data?.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* createHotelNestedSubCategory(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { payload, onClose } = action.payload
    const { data } = yield call(
      axios.post,
      `${baseUrl}/hotel/nested-nested-subcategories/`,
      payload
    )
    if (data.success) {
      onClose()
      const { data: newData } = yield call(
        axios.get,
        `${baseUrl}/hotel/hotel-config/items/hierarchy/?nested_subcategory=${payload.nested_subcategory}`
      )
      if (newData.success) {
        yield put(slice.actions.setHotelServiceItemList(newData?.data))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* editHotelNestedSubCategory(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { payload, parentId, onClose } = action.payload
    const { data } = yield call(
      axios.patch,
      `${baseUrl}/hotel/nested-nested-subcategories/${payload.nested_subcategory_id}/`,
      payload
    )
    if (data.success) {
      onClose()
      const { data: newData } = yield call(
        axios.get,
        `${baseUrl}/hotel/hotel-config/items/hierarchy/?nested_subcategory=${parentId}`
      )
      if (newData.success) {
        yield put(slice.actions.setHotelServiceItemList(newData?.data))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* deleteHotelNestedSubCategory(action) {
  try {
    yield put(appActions.setIsLoading(true))

    const { id, sub_category } = action.payload
    const { data } = yield call(axios.delete, `${baseUrl}/hotel/nested-nested-subcategories/${id}/`)
    if (data.success) {
      const { data: newData } = yield call(
        axios.get,
        `${baseUrl}/hotel/hotel-config/items/hierarchy/?nested_subcategory=${sub_category}`
      )
      if (newData.success) {
        yield put(slice.actions.setHotelServiceItemList(newData?.data))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getHotelServiceItem(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { nestedId } = action.payload
    const { data } = yield call(
      axios.get,
      `${baseUrl}/hotel/hotel-config/items/hierarchy/?nested_subcategory=${nestedId}`
    )
    if (data.success) {
      yield put(slice.actions.setHotelServiceItemList(data?.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* deleteHotelServiceItem(action) {
  try {
    yield put(appActions.setIsLoading(true))

    const { id, nestedId } = action.payload
    const { data } = yield call(axios.delete, `${baseUrl}/hotel/hotel-configs/items/${id}/`)
    if (data.success) {
      const { data: newData } = yield call(
        axios.get,
        `${baseUrl}/hotel/hotel-config/items/hierarchy/?nested_subcategory=${nestedId}`
      )
      if (newData.success) {
        yield put(slice.actions.setHotelServiceItemList(newData?.data))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* createCategoryItems(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { payload, id, onClose } = action.payload
    const { data } = yield call(axios.post, `${baseUrl}/hotel/hotel-configs/items/`, payload)
    if (data?.success) {
      onClose()
      const { data: newData } = yield call(
        axios.get,
        `${baseUrl}/hotel/hotel-config/items/hierarchy/?nested_subcategory=${id}`
      )
      if (newData?.success) {
        yield put(slice.actions.setHotelServiceItemList(newData?.data))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* editCategoryItems(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { payload, id, onClose } = action.payload
    const { itemId } = yield select((store) => store?.hotel)
    const { data } = yield call(
      axios.patch,
      `${baseUrl}/hotel/hotel-configs/items/${itemId}/`,
      payload
    )
    if (data?.success) {
      onClose()
      const { data: newData } = yield call(
        axios.get,
        `${baseUrl}/hotel/hotel-config/items/hierarchy/?nested_subcategory=${id}`
      )
      if (newData?.success) {
        yield put(slice.actions.setHotelServiceItemList(newData?.data))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* getCategoryItems(action) {
  try {
    yield put(appActions.setIsLoading(true))
    const { data } = yield call(
      axios.get,
      `${baseUrl}/hotel/hotel-configs/items/?item_id=${action.payload}`
    )
    if (data?.success) {
      yield put(slice.actions.setCategoryItemDetails(data?.data))
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* uploadImage(action) {
  try {
    yield put(appActions.setIsLoading(true))

    const { data: Image, fieldKey, type, index, sectionKey } = action.payload
    const { data } = yield call(axios.post, `${baseUrl}/trivia/media/`, Image)

    if (data?.success) {
      const imageId = data?.data?.id

      if (type === "hotelCategory") {
        yield put(slice.actions.setCategoryImageId(imageId))
      } else if (type === "signature_dishes") {
        yield put(slice.actions.setSignatureDishImageId({ index, fieldKey, id: imageId }))
      } else if (type === "pdf") {
        yield put(slice.actions.setCategoryImageId(imageId))
      } else if (fieldKey && sectionKey) {
        yield put(
          slice.actions.setImageId({
            sectionKey,
            key: fieldKey,
            id: imageId
          })
        )
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}

export function* changeCategoryOrder(action) {
  yield put(appActions.setIsLoading(true))
  try {
    const { hotelID } = yield select((store) => store?.hotel)
    const { data } = yield call(
      axios.post,
      `${baseUrl}/hotel/configurations/order/`,
      action.payload
    )
    if (data.success) {
      const { data: newData } = yield call(
        axios.get,
        `${baseUrl}/hotel/configurations/?hotel_id=${hotelID}`
      )
      if (newData.success) {
        yield put(slice.actions.setHotelCategoryList(newData?.data))
      }
    }
  } catch (e) {
    console.log(e)
  }
  yield put(appActions.setIsLoading(false))
}
